import { render } from "./ViewProject.vue?vue&type=template&id=643b82f6&scoped=true&ts=true"
import script from "./ViewProject.vue?vue&type=script&lang=ts"
export * from "./ViewProject.vue?vue&type=script&lang=ts"

import "./ViewProject.vue?vue&type=style&index=0&id=643b82f6&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643b82f6"]])

export default __exports__